module.exports = __webpack_public_path__ + "img/device_1002_2.11c7ba7d.svg";